import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'

const apiConst = {
  // 随机匹配相关接口
  match_base_list: baseAPI + baseUrl + 'config/match/base/list',
  match_base_update: baseAPI + baseUrl + 'config/match/base/update',
  match_base_add: baseAPI + baseUrl + 'config/match/base/add',
  match_base_copy: baseAPI + baseUrl + 'config/match/base/copy',
  match_base_delete: baseAPI + baseUrl + 'config/match/base/delete',
  match_rule_list: baseAPI + baseUrl + 'config/match/rule/list',
  match_rule_update: baseAPI + baseUrl + 'config/match/rule/update',
  match_rule_add: baseAPI + baseUrl + 'config/match/rule/add',
  match_rule_copy: baseAPI + baseUrl + 'config/match/rule/copy',
  match_rule_delete: baseAPI + baseUrl + 'config/match/rule/delete',
  sign_list: baseAPI + baseUrl + 'config/user_sign/list',
}

export const signListReq = async (page, data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.sign_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: {
      data: {
        signType: 'match',
        countryCode: '',
        signTemplate: '',
        valid: 1,
      },
      page: page || 1,
    },
  })
  return res
}

export const matchListReq = async (data, page) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.match_base_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      page: page,
    },
    data,
  })
  return res
}

export const matchListUpdateReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.match_base_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data,
  })
  return res
}

export const matchListAddReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.match_base_add,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data,
  })
  return res
}

export const matchListCopyReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.match_base_copy,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data,
  })
  return res
}

export const matchListDeleteReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.match_base_delete,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data,
  })
  return res
}

export const matchRuleReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.match_rule_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      page: data.page,
    },
    data,
  })
  return res
}

export const matchRuleUpdateReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.match_rule_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data,
  })
  return res
}

export const matchRuleAddReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.match_rule_add,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data,
  })
  return res
}

export const matchRuleCopyReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.match_rule_copy,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data,
  })
  return res
}

export const matchRuleDeleteReq = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.match_rule_delete,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data,
  })
  return res
}
